const indexItems = [
  { id: 'idx-1', title: '动作冒险', count: '1,280+', desc: '热血刺激、高能对决，肾上腺素飙升的观影选择', icon: 'ri-sword-line' },
  { id: 'idx-2', title: '喜剧搞笑', count: '960+', desc: '轻松解压、爆笑不断，日常快乐的源泉', icon: 'ri-emotion-happy-line' },
  { id: 'idx-3', title: '爱情浪漫', count: '820+', desc: '甜蜜心动、温暖治愈，感受爱的千百种模样', icon: 'ri-heart-line' },
  { id: 'idx-4', title: '科幻奇幻', count: '650+', desc: '脑洞大开、视觉震撼，探索未知想象世界', icon: 'ri-rocket-line' },
  { id: 'idx-5', title: '悬疑惊悚', count: '740+', desc: '烧脑反转、紧张刺激，挑战你的推理极限', icon: 'ri-search-eye-line' },
  { id: 'idx-6', title: '战争历史', count: '520+', desc: '恢弘史诗、真实震撼，铭记历史的重量', icon: 'ri-flag-line' },
  { id: 'idx-7', title: '动画家庭', count: '890+', desc: '温馨童趣、老少皆宜，全家共享欢乐时光', icon: 'ri-home-smile-line' },
];

const mediaItems = [
  {
    id: 'media-1',
    title: '本周必看 · 新片预告速览',
    desc: '精选本周即将上线的最新电影与剧集预告片合集，抢先一睹精彩内容，提前锁定你的观影清单。',
    duration: '12:35',
    views: '18.2万',
    tag: '新片预告',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20trailer%20thumbnail%20with%20play%20button%20overlay%20on%20warm%20dark%20background%20elegant%20movie%20preview%20aesthetic%20with%20soft%20golden%20lighting%20dramatic%20atmosphere%20and%20cinematic%20composition&width=800&height=500&seq=media-2026-01&orientation=landscape',
    alt: '本周必看新片预告速览',
  },
  {
    id: 'media-2',
    title: '热播剧 · 高能名场面剪辑',
    desc: '当季最火剧集的高光时刻全收录，名场面一网打尽，重温那些让人拍案叫绝的精彩瞬间。',
    duration: '08:22',
    views: '25.6万',
    tag: '精彩剪辑',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20television%20show%20highlight%20montage%20thumbnail%20with%20warm%20amber%20lighting%20on%20dark%20background%20emotional%20scene%20atmosphere%20cinematic%20drama%20aesthetic%20with%20soft%20golden%20glow&width=800&height=500&seq=media-2026-02&orientation=landscape',
    alt: '热播剧高能名场面剪辑',
  },
  {
    id: 'media-3',
    title: '幕后花絮 · 你不知道的拍摄故事',
    desc: '走进热门影视作品的幕后世界，看导演和演员如何将剧本变为银幕上的经典画面。',
    duration: '15:10',
    views: '9.8万',
    tag: '幕后花絮',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20camera%20and%20director%20chair%20on%20warm%20cinematic%20dark%20background%20movie%20production%20atmosphere%20with%20soft%20golden%20lighting%20elegant%20film%20set%20aesthetic&width=800&height=500&seq=media-2026-03&orientation=landscape',
    alt: '幕后花絮你不知道的拍摄故事',
  },
  {
    id: 'media-4',
    title: '经典回眸 · 那些年我们追过的电影',
    desc: '回顾影史经典作品中的不朽片段，感受光影艺术的永恒魅力，致敬伟大的电影人。',
    duration: '20:05',
    views: '13.4万',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20strip%20and%20classic%20movie%20elements%20on%20warm%20dark%20cinematic%20background%20nostalgic%20golden%20age%20cinema%20aesthetic%20with%20soft%20amber%20lighting%20elegant%20timeless%20atmosphere&width=800&height=500&seq=media-2026-04&orientation=landscape',
    alt: '经典回眸那些年我们追过的电影',
  },
];

const faqItems = [
  {
    id: 'faq-1',
    question: '春夜影院收费吗？',
    answer: '完全免费。春夜影院始终坚持免费观影理念，所有电影、电视剧、综艺、动漫等内容均无需付费或订阅会员，打开即可观看。我们通过广告合作维持运营，不会向用户收取任何费用。',
  },
  {
    id: 'faq-2',
    question: '画质怎么样？有蓝光吗？',
    answer: '春夜影院提供多档画质选择，最高支持蓝光1080P超清画质。系统会根据您的网络状况自动推荐最优清晰度，您也可以在播放器底部手动切换画质选项，选择最适合自己的观看体验。',
  },
  {
    id: 'faq-3',
    question: '支持哪些设备观看？',
    answer: '春夜影院支持全平台观看。电脑端（Windows / Mac）通过浏览器直接访问官网入口，手机版和平板通过移动浏览器访问最新地址即可。所有设备自适应屏幕尺寸，无需下载额外软件。',
  },
  {
    id: 'faq-4',
    question: '需要注册账号吗？',
    answer: '不需要。春夜影院无需注册登录即可观看全部内容，打开官网入口或手机版地址即看即走。我们尊重用户隐私，不强制收集个人信息，为您提供最便捷的免费高清电影电视剧观看体验。',
  },
  {
    id: 'faq-5',
    question: '资源更新频率如何？',
    answer: '春夜影院每日更新，热门电视剧同步卫视播出后快速上线，电影一般在院线下映后一周内上线高清版本。综艺节目通常在播出后24小时内更新。关注最新动态获取实时更新资讯。',
  },
  {
    id: 'faq-6',
    question: '为什么叫春夜影院？',
    answer: '「春夜」取自"春夜喜雨"之意，寓意在静谧美好的夜晚为用户带来优质的影视内容。我们希望每一位观众都能在春夜影院找到属于自己的光影时刻，享受蓝光画质不缓冲流畅播放的观影体验。',
  },
];

export default function SectionsB() {
  return (
    <>
      {/* #index - 7 topic index items */}
      <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
              分类导航
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              主题索引
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              按类型快速浏览，找到你喜欢的影视内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={`${item.icon} text-primary-600 text-base`}></i>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className="text-[10px] text-foreground-400 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {item.count}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* #media - 4 media/video style cards */}
      <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
              精彩预告
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              精彩预告
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              最新影视预告片与精彩片段集锦，抢先领略光影魅力
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {mediaItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden bg-background-200 relative">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-white group-hover:scale-110 transition-all duration-200">
                      <i className="ri-play-fill text-xl md:text-2xl text-accent-500 ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-white text-[10px] px-2 py-0.5 rounded whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <span className="inline-block px-2 py-0.5 rounded-md bg-accent-50 text-accent-700 text-[10px] font-medium mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-accent-600 transition-colors duration-200 line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-3 text-[10px] text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-xs"></i>
                      {item.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* #faq - 6 expanded FAQ items */}
      <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
              常见问题
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              关于春夜影院的常见疑问，这里都有解答
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqItems.map((item) => (
              <details
                key={item.id}
                className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
                open
              >
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0 group-open:rotate-180 transition-transform duration-200">
                    <i className="ri-arrow-down-s-line text-secondary-600 text-sm"></i>
                  </div>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}